export default
{
    labels: {
      iwtk: "IWTK",
      i_want_the_kit: "QUIERO EL KIT",
      i_want_the_home_test_kit: "QUIERO EL KIT DE PRUEBA CASERA",
      home: "PÁGINA PRINCIPAL",
      about_us: "SOBRE NOSOTROS",
      // Common labels
      add: "añadir",
      new: "Nuevo",
      edit: "Editar",
      delete: "Borrar",
      restore: "Restore",
      permanent_delete: "Permanent Delete",
      name: "Nombre",
      description: "Descripción",
      search: "Buscar/Búsqueda",
      show_hide: "Show/Hide",
      action: "Action",
      show: "Mostrar",
      show_deleted: "Show Deleted",
      save: "Guardar",
      apply: "Aplicar",
      close: "Cerrar",
      filter: "Filter",
      clear_filter: "Clear Filter",
      no_data_found: "Datos no encontrados",
      clear: "Clear",
      back: "Regresar",
      enter: "Ingresar",
      // splash screen
      already_a_user: "Es usted un usuario?",
      new_user: "Nuevo usuario",
      // eligibility check
      birth_date: "Fecha de Nacimiento",
      zip_code: "Código Postal",
      county: "Condado",
      check_eligibility: "VERIFICAR ELEGIBILIDAD",
      go_back: "Regrese",
      enter_program_code : "Ingresar el código del Programa",
      validate_program_code: "Validar código de programa",
      // login page
      username: "Usuario /Nombre del Usuario",
      email: "Correo electrónico",
      password: "Contraseña",
      login: "INICIAR SESIÓN",
      forgot_password: "Olvidó su contraseña",
      terms: "Términos",
      privacy: "POLÍTICA DE PRIVACIDAD",
      register: "Registrarse",
      username_email: "",
      username_email_mobile: "Usuario/ Nombre del Usuario (correo electrónico/teléfono celular)",
      return_to_website: "Return to website",
      // register
      first_name: "Nombre",
      last_name: "Apellido",
      confirm_password: "Confirme su contraseña",
      back_to_login: "Volver a Iniciar Sesión",
      back_to_eligibility_check: "Volver a Elegibilidad",
      phone: "Número de teléfono",
      confirm_phone: "Confirme número de teléfono",
      address_line_1: "Dirección Linea 1",
      address_line_2: "Dirección Linea 2",
      gender: "Género",
      ethnicity: "Origen étnico:",
      are_you_hispanic: "¿Es usted Hispano?",
      sms: "Mensaje de Texto",
      physical:"Físico",
      mailing_address:"Dirección de envío",
      mailing_address1: "Dirección de envío línea 1",
      mailing_address2: "Dirección de envío línea 2",
      mailing_city: "Ciudad de envío",
      mailing_state: "Estado de envío",
      mailing_zipcode: "Código postal de envío",
      mailing_county: "Condado de correo",
      sex_assgined_at_birth:"Sexo asignado al nacer",
      who_do_you_have_sex_with:"¿Con quién tiene relaciones sexuales?",
      text_message: "Mensaje de Texto",
      // forgot password
      get_token: "Obtenga el código",
      already_have_a_token: "Ya tiene el Código?",
      // reset password
      reset_password: "Restablecer la contraseña",
      token: "Código",
      new_password: "Nueva contraseña",
      back_to_forgotpassword: "Regresar a Olvidó su Contraseña",
      didn_t_get_code: "No recibiste el código?",
      // verification
      verification: "Verificación",
      verify: "VERIFICAR",
      code: "Código",
      resend_verification_code: "Reenviar",
      // Risk Quiz
      risk_quiz: "Prueba de Salud Sexual",
      get_results: "OBTENER RESULTADOS",
      quiz_results: "Resultados",
      quiz_score: "Su puntaje es",
      click_for_signup: "Haga Clic  aquí para realizar pedido",
      sign_up: "",
      already_member: "",
      // Place Order
      place_order: "Hacer el Pedido",
      Order:"Pedido",
       //Profile email and password change
      pop_up_new_email:"Nuevo correo electrónico",
      pop_up_new_phone:"Nuevo teléfono",
      pop_up_confirm_email:"Confirme su correo electrónico",
      pop_up_confirm_phone:"Confirme su teléfono",
      // navbar
      help: "Ayuda",
      profile: "Perfil",
      logout: "Cerrar la sesión",
      hello: "¡Hola",
      you_are: "usted es",
      toggle_nav: "",
      select_tests: "Seleccione las pruebas",
      // Secondary Navbar Items
      Profile: "PERFIL",
      Orders: "PEDIDOS",
      Results: "RESULTADOS",
      MessageCenter:"CENTRO DE MENSAJES",
      //Risk status labels
      LowRisk:"Casi nulas probabilidades de que hayas estado expuesto a una Infección de Transmisión Sexual (ITS)",
      IntermediateRisk:"Hay bajas probabilidades de que hayas estado expuesto a una Infección de Transmisión Sexual (ITS)",
      HighRisk:"Probablemente hayas estado expuesto a una Infección de Transmisión Sexual (ITS)",
      VeryHighRisk:"Hay altas probabilidades de que hayas estado expuesto a una Infección de Transmisión Sexual (ITS)",
      points: "puntos",
      // Dashboard
      dashboard: "Tablero de mandos",
      more_info: "",
      view_orders: "",
      orders_by_state: "",
      last_days: "",
      state_name: "",
      order_count: "",
      positive_test_table: "",
      positive_count: "",
      total_tests: "",
      disease_name: "",
      // Master setting
      settings: "",
      masters: "",
      users: "",
      participants: "",
      orders: "Pedidos",
      testing: "",
      // Master race
      races: "",
      race: "Raza",
      // Master Gender Identity
      gender_identity: "Identidad de Genero",
      gender_identities: "",
      // Master Gender Identity
      sex_with: "sexo con",
      sex_withs: "",
      // Master sex at birth
      sex_at_birth: "sexo al nacer",
      sex_at_births: "Sexo en los nacimientos",
      // Master Disease
      disease: "",
      diseases: "",
      // Master How-Heard
      how_heard: "¿Cómo escuchó sobre nosotros?",
      other_how_heard: "otra forma de escuchar",
      select_how_heard: "Seleccione cómo escuchó de nosotros",
      phone_number_positive_result: "¿A qué número de teléfono debemos llamar para informarle de un resultado positivo?",
      // Master Specimen type
      specimen_type: "",
      specimen_types: "",
      // Master Clinic
      clinic: "Clínica",
      clinics: "Clínicas",
      address: "Dirección",
      state: "Estado",
      cost: "Costo",
      other_information: "Otra Información",
      spanish:"Spanish",
      address1: "",
      address2: "",
      phone1: "",
      ext1: "",
      phone2: "",
      ext2: "",
      url: "",
      city: "Ciudad",
      clinic_name: "Nombre de la clínica",
      zipcode: "Código Postal",
      // Master Gender Identity
      assay_type: "",
      assay_types: "",
      // Master Disease
      symptom: "Síntoma",
      symptoms: "Síntomas",
      // Master Sample Type
      sample_type: "Tipo de ejemplo",
      // Master How-Heard
      account: "",
      permission: "",
      role: "",
      // Master Specimen type
      status: "Estado",
      permission_name: "",
      // Master Clinic
      module_name: "",
      all: "",
      view: "Ver",
      modify: "",
      //Role
      role_name: "",
      //User
      user: "usuario",
      confirm_email: "Confirme correo electrónico",
      //Test Type
      min_17_years: "",
      once_in_3_months: "",
      genital_test: "Genital Test",
      //Test Kit
      test_kit: "",
      test_kits: "",
      select_test_type: "",
      select: "Seleccione el",
      // Order
      order_date: "Fecha del pedido",
      order_start_date: "Order Date Start",
      order_end_date: "Order Date End",
      completed_date_start: "Fecha de finalización Inicio",
      completed_date_end: "Fecha de finalización Finalización",
      order_number: "Número de Orden",
      order_history: "Order History",
      results: "Resultados",
      confirm_program_code_and_address:"Confirme el Código del Programa y la Dirección Donde Vive",
      lab_results: "Lab Results",
      lab_name: "Lab Name",
      external_order_number: "External Order Number",
      screen_reference: "Screen Reference",
      test_time: "",
      rack_tube: "",
      rlu: "",
      tests: " Pruebas",
      add_result: "",
      result: "resultado",
      send_to_preventx: "Send to Preventx",
      //report of order specimen symptoms
      master_order_symptoms :"ordenar los síntomas de la muestra",
      // Participant
      is_first_order_completed: "Is first order completed?",
      participant_information: "Participant Information",
      age: "Age",
      preferred_contact: "Contacto preferido:",
      preferred_contact_method: "Contacto preferido",
      hispanic: "Hispano",
      shipping_address: "Dirección de envío",
      home:"Casa",
      home_address:"Dirección Donde Vive",
      physical_or_mailing_address:"La dirección donde vive es la misma a la dirección de envío?",
      show_map: "Show Map",
      yet_to_verified: " aún por verificar",
      // change password
      current_password: "Contraseña actual",
      change_password: "Cambiar contraseña",
      // messages
      title: "Título",
      date: "Fecha",
      message: "Mensaje",
      type: "",
      all_read: "Marcar todo como leído",
      send: "Enviar",
      loading: "cargando",
      mark_as_unread: "",
      mark_as_read: "",
      select_one: "Seleccione uno",
      // Admin
      roles: "",
      // Order view
      review: "",
      fill_ship: "",
      receive: "",
      testing_samples: "",
      final_summary: "",
      order_complete: "Orden Completa",
      order_cancelled: "Orden Cancelada",
      overview: "",
      change_status: "",
      trail: "",
      kit_requested: "",
      kit_name: "",
      test_included: "",
      test: "Prueba",
      include: "",
      sample: "",
      included_for_collection: "",
      include_for_collection: "",
      sample_id_barcode: "",
      sample_recieved: "",
      test_performed: "",
      received: "",
      collection_id_barcode: "",
      retest: "",
      lab_test_barcode: "Código de barras de laboratorio/prueba",
      test_barcode: "Código de barras de prueba",
      value: "Valor",
      add_test: "",
      approve: "",
      ship: "",
      complete: "",
      cancel: "Cancelar",
      contact_form: "",
      print_shipping_label: "",
      program_name_code: "",
      // Risk Assessment
      score: "",
      order: "",
      iwtk_privacy_policy: "Política de Privacidad de IWTK",
      john_hopkins_privacy_policy: "Prácticas de Privacidad de Johns Hopkins",
      review_assessment: "",
      risk: "",
      //Reports
      reports: "",
      participants_report: "",
      order_report: "",
      client_navigation: "",
      BCHD_negative_report: "BCHD Negative Report",
      BCHD_positive_report: "BCHD Positive Report",
      risk_score: "",
      shipment_start_date: "",
      shipment_end_date: "",
      receipt_start_date: "",
      receipt_end_date: "",
      affiliate_code: "",
      birthday: "",
      latest_order_date: "",
      latest_shipment_date: "",
      latest_receipt_date: "",
      latest_test_result: "",
      birth_date_start: "",
      birth_date_end: "",
      export: "",
      //Verify Test Results
      serial_number: "",
      //Label Report
      label_type: "",
      label_size: "",
      total_sheets: "",
      //Program Codes
      program_codes: "código del Programas",
      program_code: "código del Programa",
      zipcodes: "",
      add_to_region_lock: "",
      remove_from_region_lock: "",
      region_lock: "",
      duplicates: "",
      reminder_queues: "",
      reminder_queue: "",
      user_name: "",
      reminder_type: "",
      sent_via: "",
      sent_date: "",
      retry_count: "",
      reminder_history: "",
      language_preference: "Preferencia del Idioma",
        //Spanish Labels
      spanish_name: "",
      spanish_description: "",
      test_date_start: "",
      test_date_end: "",
      test_results: "Resultado de la prueba",
      order_results: "Resultado del pedido",
      order_samples: "Solicitar muestras",
      lab: "Lab",
      case_code: "Case Code",
      auto_reorder: "Auto Reorder",
      positive_result: "Positive Result?",
      result_displayed: "Result Displayed",
      result_name_english: "Result Name (English)",
      result_name_spanish: "Result Name (Spanish)",
      description_english: "Description (English)",
      description_spanish: "Description (Spanish)",
      test_code: "Test Code",
      n_a: "",
      generate_report: "",
      previous_status: "",
      notice: "Aviso",
      generate_labels: "",
      select_file: "",
      sample_id: "",
      important: "Importante",
      clinic_address: "Dirección de la clínica",
      clinic_phone: "Número de teléfono clínica",
      order_sequence_number: "",
      change: "cambio",
      email_verified: "",
      email_not_verified: "",
      phone_verified: "",
      phone_not_verified: "",
      date_received: "Fecha de recepción",
      positive: "Positiva",
      equivocal: "EQUIVOCAL",
      negative: "Negativo",
      clinic_choice: "Elección de clínica",
      comments: "Comentarios",
      user_profile: "Perfil del usuario",
      go_to_home_page: "",
      external_lab_key:"External lab key",

      international_STD_laboratory: "International STD Laboratory",
      n_725_wolfe_street: "725 N. Wolfe Street",
      room_319_pre_clinical_teaching_building: "Room 319, Pre-Clinical Teaching Building",
      baltimore_md_21205: "Baltimore, MD 21205",
      phone_410_614_0924: "410-614-0924",
      iwantthekit_jhmi_edu: "iwantthekit@jhmi.edu",
      laboratory_director: "Directora del Laboratorio",
      lab_CLIA_number: "",
      current_date: "Fecha de hoy",
      order_id: "Número de orden",
      date_of_birth: "Fecha de nacimiento",
      email_address_or_phone_number: "Dirección de correo electrónico o teléfono",
      i_want_the_kit_test_results: "Resultados de las pruebas de Quiero el Kit (IWTK)",
      date_test_kit_mailed_by_IWTK: "Fecha en que IWTK envió el kit de pruebas",
      date_of_specimen_testing: "Fecha de recolección de la muestra",
      collection_method_self_collected: "Método de recolección: autorecolección",
      date_tested: "Fecha de la prueba",
      reference_result_negative: "Resultado: Negativo",
      reference_result_positive: "Resultado: Positivo",
      chlamydia_vagina: "Clamidia - Vagina",
      gonorrhea_vagina: "Gonorrea - Vagina",
      trichomonas_vagina: "Trichomonas/Vagina",
      chlamydia_penis: "Clamidia - Pene",
      gonorrhea_penis: "Gonorrea - Pene",
      chlamydia_rectum: "Clamidia - Recto",
      gonorrhea_rectum: "Gonorrea - Recto",
      chlamydia_oral_pharyngeal: "Clamidia - Garganta",
      gonorrhea_oral_pharyngeal: "Gonorrea - Garganta",
      test_result: "Resultado de la prueba",
      ANNOUNCEMENT: "NOTICIAS",
      read_more: "Lee Mas",
      contact_us: "Contáctenos",
      latest_news: "Novedades",
      take_the_survey: "Responde la Encuesta",
      select_birth_date: "Seleccione Fecha de Nacimiento",
      month: "Mes",
      day: "Dia",
      year: "Año",
      select_state: "Seleccione su Estado",
      enter_zip_code: "Ingrese su Código Postal",
      january: "Enero",
      february: "Febrero",
      march: "Marzo",
      april: "Abril",
      may: "Mayo",
      june: "Junio",
      july: "Julio",
      august: "Agosto",
      september: "Septiembre",
      october: "Octubre",
      november: "Noviembre",
      december: "Diciembre",
      not_hispanic: "No hispano",
      white: "Blanco",
      black: "Negro",
      asian_pacific_islander: "Asiático/de las Islas del Pacífico",
      alaska_native_american_native: "Nativo de Alaska/Nativo Americano",
      multiracial: "Multirracial",
      unknown: "No sabe",
      press_enter_to_remove: "Presionar Intro (Enter) para eliminar",
      please_select_race: "Presione Seleccionar raza",
      female: "Mujer",
      selected: "Seleccionado",
      male: "Hombre",
      transgender_woman: "Mujer Transgénero",
      please_enter_to_select: "Presione Intro (Enter) para seleccionar",
      transgender_man: "Hombre Transgénero",
      genderqueer: "Género queer",
      non_binary: "No binario(a)",
      other: "Otro",
      not_sure: "No Estoy Seguro",
      VERIFICATION: "VERIFICACIÓN",
      didnt_get_code_resend: "¿No ha recibido el código? Re enviar",
      are_you_25_years_old_or_younger: "¿Tiene 25 años o menos?",

      yes: "Sí",
      no: "No",
      zero_one: "0-1",
      two_four: "2-4",
      five_nine: "5-9",
      ten_or_more: "10 o más",
      Always: "Siempre",
      Sometimes: "A veces",
      Never: "Nunca",

      throat_symptoms: "Síntomas en la garganta",
      sore_throat: "Dolor de garganta",
      none: "Ninguno",
      vagina_symptoms: "Síntomas en la vagina",
      discharge_liquid_coming_out: "Flujo/salida de líquido de la vagina",
      bad_or_unusual_smell_odor: "Mal olor u olor anormal",
      pain: "Dolor",
      blisters_or_sore: "Ampollas o llagas",
      unusual_bleeding: "Sangrado anormal (después de las relaciones sexuales  o entre períodos)",
      bumps_in_or_around_vagina: "Pequeños bultos dentro o alrededor de la vagina",
      pelvic_pain: "Dolor en la pelvis",
      pain_discomfort_when_i_pee: "Dolor/ molestia al orinar",
      penis_symptoms: "Síntomas en el pene",
      pain_in_penis: "Dolor en el pene",
      blood_in_urine: "Blood in urine",
      bumps_on_skin: "Pequeños bultos en la piel",
      anus_butt_symptoms: "Síntomas en el ano (trasero)",
      pain_inside: "Dolor por dentro",
      bleeding: "Sangrado",
      bumps_in_or_around_butt: "Pequeños bultos dentro o alrededor del ano (trasero)",
      our_mission: "Nuestra Misión",
      our_vision: "Nuestra Visión",
      a_world_without_STIs: "Un mundo sin ITS",
      our_values: "Nuestros Valores",
      our_partners: "Nuestros Socios",
      take_control_know_your_status: "Toma El Control, Conoce Tu Situación",
      what_are_stis: "¿QUÉ SON LAS ITS?",
      are_you_at_risk: "¿ESTÁS EN RIESGO?",
      get_tested: "HÁGASE LA PRUEBA",
      SERVICES_and_RESOURCES: "SERVICIOS Y RECURSOS",
      FAQs: "PREGUNTAS FRECUENTES",
      select_language: "Select Language",

      invalid: "Invalid",
      Yes: "Sí",
      No: "No",
      change_email: "Cambiar electrónico",
      change_phone: "Cambiar teléfono",
      very_high: "muy alto",
      high: "alto",
      intermediate: "intermedio",
      low: "bajo",
      print_results_report:"Imprimir el Reporte de los resultados",
      announcement: "Announcement",

      of:"de",
      admin:"admin",
      superadmin:"superadmin",
      orders_results: "Pedidos / Resultados",
      email_address: "Dirección de correo electrónico",
      spanish_cost: "Spanish Cost",

      submitted_status: "Enviado",
      approved_status: "Aprobado",
      shipped_status: "Enviado",
      received_status: "Recibido",
      testing_status: "Pruebas",
      review_status: "Revisión",
      complete_status: "Completo",
      cancelled_status: "Cancelados",
      incomplete_status: "Incompleto",
      "sent to preventx_status": "Enviado a preventx",

      None: "Ninguno",
      Cancelled: "Cancelados",
      Pending: "Pendiente",
      continue:"Continuar",
      eligibility_override: "Eligibility Override",

      // Extra
      // password_changed_successfully: "Contraseña cambiada con éxito"

      enter_zip_code_of_your_physical_home_adress: "Ingrese el Código Postal de la Dirección Donde Vive",
      enter_physical_home_address_line_1:"Dirección donde vive linea 1",
      enter_physical_home_address_line_2:"Dirección donde vive linea 2",
      would_you_like_test_hiv_at_home:"Le gustaría ordenar un kit de prueba casera de detección del VIH?",
      visit_native_test:"Visite Native Test",

      external_lab: "External Lab Key",
      sample_type: "Sample Type",

      syphilis: "Syphilis",
      hepatits: "Hepatitis C",

      kit_type: "Tipo de equipo",
      race_label: "Hemos actualizado los valores de la carrera en nuestra base de datos.<br>Seleccione una nueva carrera de las que se enumeran a continuación.",
      report_order: "Orden de informe",
      date_specimen_received: "Fecha de recepción de la muestra", 
      date_test_completed: "Fecha de finalización de la prueba"
    },
    strings: {
      and:"y",
      splash_page: "¡Bienvenido!",
      login_account: "¡Bienvenido! Inicie sesión en su cuenta.",
      agreement: "Al hacer clic en Iniciar sesión, acepta nuestros",
      acknowledge: "y ha leído y reconocido nuestra",

      program_eligibility_check: "Verificación de Elegibilidad para el Programa",
      program_eligibility_check_text: "Por favor ingrese la siguiente información para verificar si es elegible para el Programa",
      select_your_state: "Seleccione el Estado",
      register_account: "Crear una cuenta nueva.",
      register_consent_message: "Al inscribirme en este programa, doy mi consentimiento para recibir mensajes y actualizaciones de IWTK sobre mis pedidos y otros recordatorios  de carácter general.",
      register_account_success: "Usuario registrado con éxito.",
      please_validate_program_code: "Por favor valide el código del programa",
      verify_account_success: "Usuario verificado con éxito",
      select_your_city: "Seleccione su ciudad",
      select_your_county: "Seleccione su condado",
      select_your_home_county: "Seleccione su casa condado",
      select_your_home_state:"Seleccione su casa estado",
      quiz_account: "Si has tenido actividad sexual, las siguientes preguntas calcularán las probabilidades de que hayas estado expuesto a una Infección de Transmisión Sexual (ITS).",
      program_code_valid_not_allowed_override: "El código del programa es válido.",
      program_code_valid: "El código del Programa es válido",
      program_code_invalid: " no es un código de programa válido.",
      place_order_text: "Seleccione sus pruebas.",
      retesting: "¿Va a volver a realizarse la prueba después del tratamiento?",
      used_in_past: "¿Ha usado IWTK en el pasado?",
      first_sti_test: "¿Es esta tu primera prueba de ITS?",
      client_navigator: "¿Desea que un asesor de salud lo contacte para darle  información sobre otros recursos y servicios? Los asesores de salud son miembros de nuestro equipo que pueden responder preguntas sobre los resultados de sus pruebas,  ayudarle a hacer una cita con un proveedor de atención médica,  ayudarle a inscribirse en un seguro médico y vincularlo con los servicios de prevención  y tratamiento para el VIH",

      clinic_info: "Elija una clínica / departamento de salud pública que pueda ayudarlo si tiene un resultado positivo. Algunos centros clínicos cobran una tarifa, y esta tarifa se puede ver al seleccionar la clínica",
      clinic_info_for_md: "Por favor seleccione la clínica que desea visitar en caso de tener un resultado positivo. Si una de sus pruebas sale positiva, por favor contacte a su proveedor de salud lo más pronto posible para que reciba tratamiento. IWTK no da tratamiento ni contacta a los proveedores de salud.",
      clinic_test_results: "Si uno de sus resultados es positive, por favor contacte a su proveedor de salud lo más pronto posible para que reciba tratamiento. IWTK no da tratamiento. Para imprimir sus resultados, vaya a: Imprimir el Reporte de los Resultados o capture sus resultados desde su pantalla para mostrárselos al proveedor de salud.",
      attestation: "Doy fe de que solicito este kit solo en mi nombre para mi uso personal",
      select_symptoms: "¿Tiene alguno de los siguientes síntomas? Por favor, seleccione todos los que correspondan.",
      empty_symptoms: "No se requieren síntomas para esta muestra.",

      be_sure_to_wait_3_months: "(Asegúrese de esperar 3 meses después de finalizado el tratamiento para volver a evaluarse)",
      how_heard_field: "Por favor complete el campo de cómo escuchó de nosotros",
      the_alaska_IWTK_testing_service_is_made_possible: "El servicio de pruebas IWTK de Alaska es posible gracias al Consorcio de Salud Tribal de Nativos de Alaska (ANTHC). Al solicitar un pedido, usted acepta que todos los resultados de sus pruebas (positivos y negativos) serán compartidos con ANTHC para garantizar un seguimiento médico adecuado. Si tiene alguna pregunta o inquietud, comuníquese con el equipo de Alaska IWTK en IWantTheKitAlaska@anthc.org o llame al 877-334-8762.",
      sti_screening_kit_message_0:"Al solicitar el kit de detección de ITS, usted acepta que sus resultados, si son positivos, se compartirán con el Centro de Epidemiología Tribal (TEC), la Oficina de Área del Servicio de Salud Indígena (IHS), el Departamento de Salud del Estado u otra autoridad de salud pública. Sus resultados también pueden compartirse con su proveedor tratante. Si es residente de Nebraska, acepta que sus resultados, incluso si son negativos, pueden informarse al Departamento de Salud y Servicios Humanos de Nebraska o a su autoridad de salud pública local, si así lo exige la ley. Usted reconoce que ha leído el Aviso de prácticas de privacidad de Johns Hopkins y la política de privacidad de IWTK, ambos disponibles al pie de página de este sitio web, y comprende cómo Johns Hopkins puede utilizar y divulgar su información.",
      sti_screening_kit_message_1:"Al solicitar el kit de detección de ITS, usted acepta que sus resultados, si son positivos, se compartirán con el Centro de Epidemiología Tribal (TEC), la Oficina de Área del Servicio de Salud Indígena (IHS), el Departamento de Salud del Estado u otra autoridad de salud pública. Sus resultados también pueden compartirse con su proveedor tratante. Si es residente de Nebraska, acepta que sus resultados, incluso si son negativos, pueden informarse al Departamento de Salud y Servicios Humanos de Nebraska o a su autoridad de salud pública local, si así lo exige la ley. Usted reconoce que ha leído el Aviso de prácticas de privacidad de Johns Hopkins y la política de privacidad de IWTK, ambos disponibles al pie de página de este sitio web, y comprende cómo Johns Hopkins puede utilizar y divulgar su información.",
      sti_screening_kit_message_2:", ambos están disponibles en el pie de página de este sitio web, y comprende cómo Johns Hopkins puede usar y divulgar su información.",
      in_order_to_assist_with_your_medical: "Para poder asistirle con el cuidado de su salud a través de la Clínica de Bienestar y Salud Sexual BCHD, su nombre, fecha de nacimiento, el estudio pedido y los resultados negativos se compartirán con su proveedor de salud.",
      check_this_box_if_you_do_NOT_want: "Marque esta casilla si usted NO quiere que los resultados negativos se compartan con BCHD (Tenga en cuenta: todos los resultados positivos se informan al departamento de salud para ayudarlo a recibir la mejor atención posible. La ley exige que se notifiquen los resultados de algunos estudios.)",
      verification: "Por favor revise el correo electrónico/ mensaje de texto de bienvenida que acabamos de enviarle, e introduzca el código que está en ese correo electrónico/mensaje de texto para verificar su cuenta. El usuario es el correo electrónico, o el teléfono.",
      are_you_sure_you_want_to_logout: "Está seguro que quiere cerrar la sesión?",

      forgot_account: "Ingrese su nombre de usuario (dirección de correo electrónico o número de teléfono móvil) y le enviaremos un token para restablecer su contraseña.",
      forgot_password_success: "Por favor revise su correo electrónico / SMS. Recibirá un código de recuperación de contraseña en su correo electrónico / teléfono en unos minutos.",
      reset_account: "Por favor ingrese el código que se le envió en su correo electrónico / teléfono",
      reset_account_success: "Su contraseña se ha restablecido correctamente. Ahora puede iniciar sesión con su nueva contraseña.",
      new_password: "Necesita establecer una nueva contraseña para su cuenta.",
      hiv_kit_once_in_3_month: "Los kits de VIH solo se pueden solicitar una vez cada 90 días. Su último kit de VIH se solicitó el",

      when_you_are_done_looking_at_your_account: "Cuando termine de ver su cuenta, utilice el botón de la esquina superior derecha de la pantalla y cierre el navegador para salir completamente del sistema.",
      we_have_recenlty_move_to_new_system: "Recientemente hemos migrado a un nuevo sistema. Si usted ya tiene una cuenta con IWTK y no puede iniciar la sesión, necesitara ir a la liga  al final “olvidó su contraseña” y crear una nueva contraseña",
      sorry_we_could_not_find_that_page: "Sorry we could not find that page :(",
      this_page_is_coming_soon: "This page is coming soon :)",
      you_are_not_eligible_for_the_program_as_you_are_not_atleast_14_years_old:"Usted no es elegible para el programa porque no tiene más de 14 años.",

      select_one_status:"Seleccione un estado",
      results_are_uploaded_for:"Results are not uploaded for (- Missing)",
      enter_email_and_confirm_email: "Por favor introduzca correo electrónico y confirme correo electrónico",
      your_email_and_confirm_email_do_not_match: "Your email and Confirm email do not match",
      enter_phone_and_confirm_phone: "Por favor introduzca teléfono y confirme teléfono",
      your_phone_and_confirm_phone_do_not_match: "Your phone and Confirm phone do not match",

      are_you_25_years_old_or_younger: "¿Tiene 25 años o menos?",
      have_you_had_either_a_new_sex_partner_or_multiple_partners_in_the_last_90_days: "¿Ha tenido una nueva pareja sexual o varias parejas (o ambos) en los últimos 90 días?",
      right_now_do_you_have_more_than_one_sex_partner: "Tiene ahora más de una pareja sexual?",
      have_you_ever_been_told_you_had_a_sexually_transmitted_infection_or_have_you_ever_been_treated_for_a_sexually_transmitted_infection: "¿Le han dicho alguna vez que tiene una infección de transmisión sexual o le han tratado alguna vez por una infección de transmisión sexual?",
      how_many_sex_partners_have_you_had_in_the_last_90_days: "¿Cuántas parejas sexuales ha tenido en los últimos 90 días?",
      when_you_have_sex_do_you_use_a_condom: "Cuando tiene relaciones sexuales, ¿usa preservativo?",

      you_are_eligible_for_the_program_you_can_register_now: "Usted es elegible para el programa. Puede registrarse ahora.",
      you_need_to_check_your_eligibility_before_registering: " Necesita checar su elegibilidad antes de registrarse",
      fill_the_risk_assessment_before_placing_order: "Fill the risk assessment before placing order.",
      complete_your_first_order: "Complete su primer pedido",

      you_have_a: "Tiene un ",
      risk_of_STIs: " riesgo de contraer ITS ",

      press_enter_to_select:"Presione “enter” para seleccionar",
      press_enter_to_remove:"Presione “enter” para remover ",

      // Program code
      program_code_info: "¿Se le ha proporcionado un código de programa? De lo contrario, omita este campo.",
      invalid_state_or_zipcode:"Código Postal o Estado Invalido",
      required:"required",
      Baltimore_City_Health_Department_Sexual_Health_and_Wellness_Clinic_East:"Departamento de Salud de la Ciudad de Baltimore – Servicios de Salud Sexual y Bienestar - Clínica  Zona Este" ,
      Baltimore_City_Health_Department_Sexual_Health_and_Wellness_Clinic_West:"Departamento de Salud de la Ciudad de Baltimore – Servicios de Salud Sexual y Bienestar - Clínica  Zona Oeste" ,
      new_order_message:"Si necesita actualizar la dirección de envio, hágalo en el perfil de su cuenta de IWTK.",

      //Cancel Order Statuses
      ship_to_address_are_incorrect_or_incomplete:"uno o más detalles de la dirección de envío son incorrectos o están incompletos. Por favor, revise y vuelva a realizar el pedido con la información de dirección actualizada.",
      canceled_ordered_penile_and_vaginal_swab:"usted ordenó un hisopo vaginal y otro hisopo para el pene. IWTK permite a los clientes pedir solo un hisopo genital. Por favor vuelva a ordenar y seleccione el hisopo genital adecuado para usted",
      incomplete_or_invalid_name:"nombre incompleto o no válido.",
      Undelivered_kit:"el kit no fue entregado, fue devuelto por servicio postal. Comprueba tu dirección y vuele a realizar el pedido",
      Contact_returned:"el formulario de contacto no ha sido devuelto.",
      Swab_condition_testing:"el estado del hisopo es inaceptable para la prueba.",
      Swab_returned:"no se ha devuelto el hisopo.",
      Kit_expired:"el kit caducó antes de la fecha de recolección de la muestra.",
      other:"otros",

      cancellation_reason: "Razon de cancelacion",
      select_cancel_reason: "Seleccione el motivo de cancelación",
      return_to_order: "Volver al pedido",
      select_cancellation_reason: "Seleccione un motivo de cancelación válido",
      select_how_heard_least_3: "Por favor seleccione al menos una opción. Puede seleccionar hasta 3 opciones.",
      max_how_heard:"Puede seleccionar máximo hasta 3 opciones. Primero remueva la opción seleccionada para seleccionar una opción diferente.",

      //Syphilis
      positive_syphilis: "Have you had a positive syphilis test in the past?",
      treated_syphilis: "Have you ever been treated for syphilis? Usually, treatment is a shot in the butt.",
      exposed_syphilis: "Are you worried you may recently have been exposed to syphilis?",
      pregnat_syphilis: "Are you pregnant or do you think you could be pregnant?",
      one_ans: "Please choose one answer.",

      //hepatitis c
      positive_hepatitis: "Have you had a positive Hepatitis C test in the past?",
      treated_hepatitis: "Have you ever been treated for Hepatitis C?",
      symptoms_selection_text : "¿Está experimentando alguno de los siguientes síntomas? Por favor seleccione todas las respuestas válidas.",
      syphilis_selection_text : "Sus respuestas a las preguntas sobre la sífilis ayudarán a sus proveedores de atención médica si su prueba es positiva.",
      hepatits_selection_text: "Sus respuestas a las preguntas sobre la hepatitis C ayudarán a sus proveedores de atención médica si su prueba es positiva.",
      region_lock_text: "Elija las ubicaciones donde está disponible este ejemplar."
    },
    validations: {
      either_phone_or_email_is_required: "El teléfono o su correo electrónico son requeridos",
      enter_email: "Por favor ingrese correo electrónico",
      enter_confirm_email: "Por favor confirme su correo electrónico",
      enter_confirm_phone: "Por favor confirme su número de teléfono",
      enter_phone: "Introduzca el número de teléfono",
      enter_valid_email: "Por favor introduzca un correo electrónico válido",
      enter_password: "Por favor ingrese contraseña",
      enter_token: "Por favor ingrese el código",
      enter_old_password: "La contraseña actual no es correcta",
      enter_new_password: "Por favor introduzca nueva contraseña",
      enter_confirm_password: "Por favor confirme su contraseña",
      password_validation: "La contraseña debe tener al menos 8 caracteres",
      confirm_password_validation: "Su contraseña y contraseña de confirmación no coinciden",
      confirm_email_validation: "Tu correo electrónico y el de confirmación no coinciden",
      enter_name: "Por favor ingrese el nombre",
      confirm_phone_validation: "Tu teléfono y el de confirmación no coinciden",
      enter_description: "Introduzca una descripción",
      select_test_kit: "Seleccione el kit de prueba",
      select_how_heard: "Seleccione cómo escuchó",
      select_test_types: "Seleccione los tipos de prueba",
      enter_user_name: "Por favor ingrese el nombre del usario",
      enter_birth_date: "Ingrese la fecha de nacimiento",
      enter_zip_code: "Ingrese el código postal",
      select_state: "Seleccione el estado",
      enter_first_name: "Por favor ingrese el nombre",
      enter_last_name: "Por favor ingrese el apellido",
      enter_address: "Ingrese dirección donde vive 1",
      enter_address_1: "Ingrese dirección donde vive 1",
      select_gender: "Por favor seleccione la identidad de género",
      select_sex_with: "Por favor seleccione con quién tiene relaciones sexuales",
      please_select_all_that_apply: "Por favor seleccione todas las respuestas válidas",
      select_race: "Por favor seleccione la raza",
      race: "Por favor ingrese raza",
      hispanic: "Por favor ingrese si es hispano o no",
      gender: "Por favor ingrese género",
      select_county: "Seleccione el condado donde vive",
      select_city: "Seleccione la ciudad donde vive",
      select_test_kits: "Seleccione kits de prueba",
      select_clinic: "Seleccione la clínica",
      attestation: "Se requiere certificación",
      enter_current_password: "Introduzca la contraseña actual",
      phone_validation: "El número de teléfono no puede tener más de 15 caracteres",
      phone_min_validation: "El número de teléfono debe tener al menos 11 caracteres",
      phone_regex: "El número teléfono debe estar en un formato válido.",
      select_preferred_contact_method: "Por favor seleccione el método de contacto preferido",
      select_language_preference: "Por favor seleccione preferencia de idioma",
      select_hispanic: "Seleccione hispano",
      select_roles: "Seleccione roles",
      select_permissions: "Seleccione los permisos",
      select_disease: "Seleccione enfermedades",
      select_assay_types: "Seleccione los tipos de ensayo",
      select_specimen_types: "Seleccione el tipo de muestra",
      select_symtoms: "Seleccione los síntomas",
      enter_cost: "Ingrese el costo",
      enter_city: "Por favor ingrese la ciudad",
      enter_code: "Por favor introduzca el código",
      username_email_mobile: "Ingrese el nombre de usuario (correo electrónico o número de teléfono celular)",
      question_1: "El campo anterior es obligatorio",
      question_2: "El campo anterior es obligatorio",
      question_3: "El campo anterior es obligatorio",
      question_4: "El campo anterior es obligatorio",
      question_5: "El campo anterior es obligatorio",
      question_6: "El campo anterior es obligatorio",

      enter_mailing_address_1:"Ingrese Dirección de envío 1",
      enter_mailing_address_2:"Ingrese Dirección de envío 2",
      enter_mailing_city:"Ingrese la ciudad de envío",
      enter_mailing_state:"Ingrese el estado de envío",
      enter_mailing_county:"Ingrese el condado de envío",
      enter_mailing_zipcode:"Por favor ingrese el código postal de correo",
      select_sex_at_birth:"Por favor seleccione sexo asignado al nacer",

      test_result:"Seleccione un resultado de prueba",
      enter_end_date:"Por favor, introduzca la fecha de finalización",
      enter_start_date:"Por favor, introduzca la fecha de inicio",

      result_name_english: "Por favor seleccione el nombre del resultado",
      test_code: "Por favor ingrese el código de prueba",
      case_code: "Por favor ingrese el código del caso",
      select_lab: "Por favor seleccione laboratorio",
    }
  };
